import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import type { CalendarListParams, CalendarListResponse } from "./types";

/**
 * Weekly-grid feed. Polls every 30s while the tab is focused; ETag-cached
 * via fetchJsonWithEtag so most polls cost a 304 round-trip only.
 * refetchIntervalInBackground is intentionally false so hidden tabs stop
 * polling — there's no point pinging the backend for a UI nobody can see.
 */
export function useCalendarQuery(params: CalendarListParams) {
  return useQuery<CalendarListResponse>({
    queryKey: [
      "calendar",
      params.start,
      params.end,
      (params.materials ?? []).join(","),
      (params.types ?? []).join(","),
      (params.importance ?? []).join(","),
      (params.status ?? []).join(","),
    ],
    queryFn: () => api.listCalendar(params),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    staleTime: 15_000,
  });
}
